"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);
var _phone = require('shared/services/phone');
var _org = require('shared/selectors/org');
var _features = require('shared/selectors/org/features');
var _team = require('shared/selectors/team');
var _user = require('shared/selectors/user');



var _entities = require('shared/transforms/entities');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');
var _hooks3 = require('./hooks');

var _RightSide = require('web/components/RightSide');
var _EntityNotFoundScreen = require('web/screens/EntityNotFoundScreen'); var _EntityNotFoundScreen2 = _interopRequireDefault(_EntityNotFoundScreen);

var _Chips = require('web/components/Chips'); var _Chips2 = _interopRequireDefault(_Chips);
var _ConfirmDeleteTeamModal = require('./ConfirmDeleteTeamModal'); var _ConfirmDeleteTeamModal2 = _interopRequireDefault(_ConfirmDeleteTeamModal);
var _Header = require('./Header'); var _Header2 = _interopRequireDefault(_Header);
var _BlockListTab = require('./BlockListTab'); var _BlockListTab2 = _interopRequireDefault(_BlockListTab);
var _CallForwardingTab = require('./CallForwardingTab'); var _CallForwardingTab2 = _interopRequireDefault(_CallForwardingTab);
var _KeywordsTab = require('./KeywordsTab'); var _KeywordsTab2 = _interopRequireDefault(_KeywordsTab);
var _InfoTab = require('./InfoTab'); var _InfoTab2 = _interopRequireDefault(_InfoTab);
var _ScheduleTab = require('./ScheduleTab'); var _ScheduleTab2 = _interopRequireDefault(_ScheduleTab);
var _useBusyReplyToggle = require('./hooks/useBusyReplyToggle'); var _useBusyReplyToggle2 = _interopRequireDefault(_useBusyReplyToggle);









var TeamTab; (function (TeamTab) { const INFO = 0; TeamTab[TeamTab["INFO"] = INFO] = "INFO"; const AUTO_REPLY = INFO + 1; TeamTab[TeamTab["AUTO_REPLY"] = AUTO_REPLY] = "AUTO_REPLY"; const KEYWORDS = AUTO_REPLY + 1; TeamTab[TeamTab["KEYWORDS"] = KEYWORDS] = "KEYWORDS"; const CALL_FORWARDING = KEYWORDS + 1; TeamTab[TeamTab["CALL_FORWARDING"] = CALL_FORWARDING] = "CALL_FORWARDING"; const BLOCK_LIST = CALL_FORWARDING + 1; TeamTab[TeamTab["BLOCK_LIST"] = BLOCK_LIST] = "BLOCK_LIST"; })(TeamTab || (TeamTab = {}));
const infoTabs = [
  { tab: TeamTab.INFO, label: "Overview" },
  { tab: TeamTab.AUTO_REPLY, label: "Auto-Reply" },
]
const keywordsTab = { tab: TeamTab.KEYWORDS, label: "Keywords" }
const callForwardingTab = { tab: TeamTab.CALL_FORWARDING, label: "Call Forwarding" }
const blockListTab = { tab: TeamTab.BLOCK_LIST, label: "Block List" }

const TeamPage = ({
  teamKey,
  orgKey,
  onStartChat,
  conversationKey,
}) => {
  const team = _hooks.useAppSelector.call(void 0, state => _team.selectTeamByKey.call(void 0, state, teamKey))
  const hasPhoneNumber = !!_optionalChain([team, 'optionalAccess', _ => _.PhoneNumber])
  const teamEntity = _react.useMemo.call(void 0, 
    () => team &&
      _entities.mapTeamToEntity.call(void 0, {}, (0, _entities.makeRawMembersCountTeamDescription))(team),
    [team],
  )
  const orgName = _hooks.useAppSelector.call(void 0, state => {
    const t = _team.selectTeamByKey.call(void 0, state, teamKey)
    return t && _optionalChain([_org.selectOrgByKey.call(void 0, t.OrgKey, state), 'optionalAccess', _2 => _2.Name]) || ''
  })
  const amIAnAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const canEditTeam = !_optionalChain([team, 'optionalAccess', _3 => _3.IsDefaultTeam]) && amIAnAdmin
  const canExportPhoneLogs = amIAnAdmin && _optionalChain([team, 'optionalAccess', _4 => _4.OrgKey]) === orgKey && hasPhoneNumber
  const canManagePhoneBlocks = amIAnAdmin && _optionalChain([team, 'optionalAccess', _5 => _5.OrgKey]) === orgKey && hasPhoneNumber
  const teamOrgHasKeywords = _hooks.useAppSelector.call(void 0, state => !!team && _features.selectOrgHasKeywords.call(void 0, state, team.OrgKey))
  const canSeeKeywords = hasPhoneNumber && teamOrgHasKeywords
  const canEditKeywords = amIAnAdmin && _optionalChain([team, 'optionalAccess', _6 => _6.OrgKey]) === orgKey

  const loadTeam = _react.useCallback.call(void 0, () => _actions2.default.getTeams({ TeamKeys: [teamKey] }), [teamKey])
  const hasLoadFailed = _useEntityPreload2.default.call(void 0, loadTeam)
  const [activeTab, setActiveTab] = _react.useState(TeamTab.INFO)
  const visibleTabOptions = _react.useMemo.call(void 0, 
    () => [
      ...infoTabs,
      ...canSeeKeywords ? [keywordsTab] : [],
      callForwardingTab,
      ...canManagePhoneBlocks ? [blockListTab] : [],
    ],
    [canManagePhoneBlocks, canSeeKeywords],
  )

  const {
    isDeleteModalOpen,
    onDelete,
    onCloseDeleteModal,
    onConfirmDelete,
  } = _hooks3.useDeleteTeam.call(void 0, teamKey)
  const onUpdateInfo = _hooks3.useUpdateTeam.call(void 0, teamKey)
  const { setForwardingNumber, clearForwardingNumber } = _hooks3.useCallForwarding.call(void 0, teamKey)

  const [isAutoReplyEnabled, onToggleAutoReply] =
    _hooks3.useAutoReplyToggle.call(void 0, teamKey, !!_optionalChain([teamEntity, 'optionalAccess', _7 => _7.wrappedEntity, 'access', _8 => _8.AutoReply]))

  const [isBusyReplyEnabled, onToggleBusyReply] =
    _useBusyReplyToggle2.default.call(void 0, teamKey, !!_optionalChain([teamEntity, 'optionalAccess', _9 => _9.wrappedEntity, 'access', _10 => _10.BusyReply]))

  _react.useEffect.call(void 0, () => {
    if (
      (!canManagePhoneBlocks && activeTab === TeamTab.BLOCK_LIST) ||
      (!canSeeKeywords && activeTab === TeamTab.KEYWORDS)
    ) {
      setActiveTab(TeamTab.INFO)
    }
  }, [activeTab, canManagePhoneBlocks, canSeeKeywords])

  if (hasLoadFailed) return _react2.default.createElement(_EntityNotFoundScreen2.default, { desc: "Failed to load team"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}} )
  if (!teamEntity) return null

  return (
    _react2.default.createElement(_react2.default.Fragment, { key: teamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
      , _react2.default.createElement(_Header2.default, {
        teamKey: teamKey,
        title: teamEntity.name,
        subtitle: hasPhoneNumber
          ? `${teamEntity.description} \u00b7 ${_phone.formatPhoneNumber.call(void 0, team.PhoneNumber)}`
          : teamEntity.description,
        onBack: _actions2.default.gotoDirectory,
        onStartChat: () => onStartChat(teamEntity),
        onDelete: canEditTeam ? onDelete : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
      )
      , _react2.default.createElement(_RightSide.RightSideBody, { className: "team-page--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        ,  hasPhoneNumber && (
          _react2.default.createElement('div', { className: "inbox-tabs team-page--tabs" , role: "group", 'aria-label': "Team settings" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
            , _react2.default.createElement(_Chips2.default, {
              pills: visibleTabOptions,
              activeTab: activeTab,
              onSelectTab: setActiveTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
            )
          )
        )
        , _react2.default.createElement('div', { className: "team-page--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
          ,  activeTab === TeamTab.INFO && (
            _react2.default.createElement(_InfoTab2.default, {
              teamKey: teamKey,
              orgKey: orgKey,
              conversationKey: conversationKey,
              canEditTeam: canEditTeam,
              canExportPhoneLogs: canExportPhoneLogs,
              canSeeKeywords: canSeeKeywords,
              onUpdateInfo: onUpdateInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
            )
          )
          ,  activeTab === TeamTab.BLOCK_LIST && canManagePhoneBlocks && (
            _react2.default.createElement(_BlockListTab2.default, { teamKey: teamKey, orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}} )
          )
          ,  activeTab === TeamTab.AUTO_REPLY && (
            _react2.default.createElement(_ScheduleTab2.default, {
              teamKey: teamKey,
              orgName: orgName,
              phoneNumber: _nullishCoalesce(_optionalChain([team, 'optionalAccess', _11 => _11.PhoneNumber]), () => ( '')),
              canEditReplies: amIAnAdmin,
              isAutoReplyEnabled: isAutoReplyEnabled,
              onToggleAutoReply: onToggleAutoReply,
              onUpdateAutoReplyInfo: onUpdateInfo,
              isBusyReplyEnabled: isBusyReplyEnabled,
              onToggleBusyReply: onToggleBusyReply,
              onUpdateBusyReplyInfo: onUpdateInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
            )
          )
          ,  activeTab === TeamTab.KEYWORDS && canSeeKeywords && (
            _react2.default.createElement(_KeywordsTab2.default, {
              teamKey: teamKey,
              teamName: teamEntity.name,
              phoneNumber: _nullishCoalesce(_optionalChain([team, 'optionalAccess', _12 => _12.PhoneNumber]), () => ( '')),
              canEdit: canEditKeywords, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
            )
          )
          ,  activeTab === TeamTab.CALL_FORWARDING && hasPhoneNumber && (
            _react2.default.createElement(_CallForwardingTab2.default, {
              phoneNumber: _nullishCoalesce(_optionalChain([team, 'optionalAccess', _13 => _13.PhoneNumber]), () => ( '')),
              forwardingNumber: teamEntity.wrappedEntity.ForwardingNumber,
              onSaveForwardingNumber: setForwardingNumber,
              onClearForwardingNumber: clearForwardingNumber, __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
            )
          )
        )
      )
      , _react2.default.createElement(_ConfirmDeleteTeamModal2.default, {
        isOpen: isDeleteModalOpen,
        onClose: onCloseDeleteModal,
        teamName: teamEntity.name,
        orgName: orgName,
        onProceed: onConfirmDelete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, TeamPage)
